var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const cropImage = (image_1, cropData_1, ...args_1) => __awaiter(void 0, [image_1, cropData_1, ...args_1], void 0, function* (image, cropData, targetWidth = 1920, targetHeight = 1080) {
    const canvas = document.createElement('canvas');
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx)
        throw new Error('Failed to get canvas context');
    const sourceX = Math.max(0, cropData.x);
    const sourceY = Math.max(0, cropData.y);
    ctx.drawImage(image, sourceX, sourceY, Math.min(image.width - sourceX, cropData.width), Math.min(image.height - sourceY, cropData.height), 0, 0, targetWidth, targetHeight);
    return canvas;
});
export const canvasToFile = (canvas_1, filename_1, ...args_1) => __awaiter(void 0, [canvas_1, filename_1, ...args_1], void 0, function* (canvas, filename, mimeType = 'image/jpeg') {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (!blob) {
                reject(new Error('Failed to create blob from canvas'));
                return;
            }
            const file = new File([blob], filename, { type: mimeType });
            resolve(file);
        }, mimeType, 0.95);
    });
});
